import React from "react";
import styled from "styled-components";

const Container = styled.div`
    user-select: none;
    position: relative;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    padding-top: 44px;
`;

const Placeholder = styled.div<{ focused: boolean }>`
    pointer-events: none;
    user-select: none;
    position: absolute;
    top: ${(p) => (p.focused ? 13 : 30)}px;
    transition: all 0.2s;
    color: ${(p) => (p.focused ? "#000" : "#dcdbdc")};
    font-size: ${(p) => (p.focused ? 12 : 16)}px;
`;

const Pill = styled.div<{ selected: boolean }>`
    cursor: pointer;
    padding: 0 16px;
    border-radius: 3px;
    font-size: 15px;
    white-space: nowrap;
    height: 26px;
    line-height: 22px;
    text-decoration: none;
    transition: all 0.2s ease-in-out;
    margin: 0 0 5px 5px;
    font-weight: 500;
    color: ${(p) => (p.selected ? "#fff" : "#7e7e7e")};
    background-color: ${(p) => (p.selected ? "#000" : "#e8e8e8")};
    border: 1px solid ${(p) => (p.selected ? "#000" : "#d8d8d8")};

    &:hover {
        border-color: #000;
    }
`;

interface PillsProps {
    placeholder: string;
    id: string;
    name: string;
    value: string[];
    labels: string[];
    values: string[];
    onChange: (name: string, value: string[]) => void;
}
export class Pills extends React.Component<PillsProps> {
    state = {
        focused: false,
    };

    placeholder() {
        return (
            <Placeholder focused={true}>{this.props.placeholder}</Placeholder>
        );
    }

    onChange = (val: string) => {
        const { name, value, onChange } = this.props;

        let update;
        if (!value.includes(val)) {
            update = value.slice();
            update.push(val);
        } else {
            update = value.filter((v) => v !== val);
        }

        onChange(name, update);
    };

    render() {
        const { value, labels, values } = this.props;

        return (
            <Container>
                {this.placeholder()}
                {values.map((v, i) => (
                    <Pill
                        key={`pill-${i}-${v}`}
                        selected={value.includes(v)}
                        onClick={() => this.onChange(v)}
                    >
                        {labels[i]}
                    </Pill>
                ))}
            </Container>
        );
    }
}
